import { render } from "./ProductCertificates.vue?vue&type=template&id=36995a22"
import script from "./ProductCertificates.vue?vue&type=script&lang=js"
export * from "./ProductCertificates.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__